import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Carousel, Button, Grid, Select } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import GeneralLayout from '../../layouts/general';
import DescriptionCardV2 from '../../components/DescriptionCardV2';
import styles from './index.less';
import { FormattedMessage, useIntl } from 'react-intl';
import { CommonSectionLayout } from 'src/components/POSWebsite/legacy';
import POSProductAdvanceCard from '../../components/POSProductAdvanceCard';
import ScheduleYourFreeDemo from '../../components/ScheduleYourFreeDemo';
import CustomerVoiceCard from '../../components/PosCustomerVoice';
import compareTalbeData, { compareTargetOptions } from 'src/consts/whychowbusposCompareData';
import { LOCALE_ZH } from 'src/consts';
import useLocale from 'src/hooks/useLocale';
import useSEOMeta from 'src/hooks/useSEOMetaHook';
const { useBreakpoint } = Grid;
const checked_icon = `${process.env.ASSETS_PREFIX}/assets/checked_icon.png`;
const chowbus_logo_why_chowbus_pos = `${process.env.ASSETS_PREFIX}/assets/chowbus_logo_why_chowbus_pos.png`;
const checkbox_small = `${process.env.ASSETS_PREFIX}/assets/checkbox_small.png`;
const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/switch_top.png`,
      title: `Don't settle for mediocre technology`,
      description: `Chowbus POS products are specifically designed for the ever-changing restaurant industry. Embrace the current situation with innovative solutions, aiming to save you both time and money.`,
      moreDescription: [
        {
          title: 'Save Your Time and Cost',
          content: `We'll help reduce your monthly labor expenses by over $8,000 and boost your business growth by 25%.`,
        },
        {
          title: 'No.1 in Customer Service',
          content: `We offer onsite POS installation and training, as well as 24/7 onsite support with a response time of just 30 minutes.`,
        },
        {
          title: 'Custom Solutions for Restaurants',
          content: `We specialize in providing tailor-made solutions to meet the unique needs of restaurants, regardless of their size or cuisine.`,
        },
      ],
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/switch_top.png`,
      title: '我们不满足于平凡的技术',
      description:
        'Chowbus POS专为不断发展的餐饮行业而设计。我们提供创新的解决方案，旨在帮助您节省时间和金钱，应对当前环境下的各种挑战。',
      moreDescription: [
        {
          title: '节省您的时间和成本',
          content: `我们将帮助您每月节省超过8,000美元的人工成本，并提高至少25%营业额。`,
        },
        {
          title: '一流的客户服务体验',
          content: `我们提供现场POS安装和培训，并且提供24/7现场支持，响应时间在30分钟以内。`,
        },
        {
          title: '餐厅定制化解决方案',
          content: `我们专注于为餐厅提供量身定制的解决方案，以满足不同规模和菜系的独特需求。`,
        },
      ],
    },
  },
  features: {
    en: {
      title: `Compare Chowbus POS and experience the difference.`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_1.png`,
          imageAlt: 'No More Tablet Hell',
          title: 'No More Tablet Hell',
          description:
            'Consolidate all your third party delivery platforms into one place and say goodbye to the wall of tablets.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_2.png`,
          imageAlt: 'No More Missing or Incorrect Orders',
          title: 'No More Missing or Incorrect Orders',
          description:
            'Orders from the third party delivery platforms sent directly to the POS systems, which means accurate orders, every time.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_3_0.png`,
          imageAlt: 'One Menu for All',
          title: 'One Menu for All',
          description:
            'Managing multiple menus and stock control has never been easier. Edit, snooze, and sync menus across all your channels in seconds.',
        },
      ],
    },
    zh: {
      title: `比较Chowbus POS，体验不同之处`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX} /products/products_pos_thirdparty_integration_feature_1.png`,
          imageAlt: '无需繁杂的设备',
          title: '无需繁杂的设备',
          description: '所有第三方外卖平台订单直接导入到Chowbus POS系统中.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_2.png`,
          imageAlt: '杜绝延迟或遗失订单',
          title: '杜绝延迟或遗失订单',
          description: '一键导入所有订单，将遗失订单或延迟订单的情况从源头杜绝.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_3.png`,
          imageAlt: '统一管理菜单',
          title: '统一管理菜单',
          description: '在Chowbus POS上统一管理多个外卖平台的菜单，批量上下架，改价格，库存管理等.',
        },
      ],
    },
  },

  advances: {
    en: {
      title: 'Opt for technology solutions that provide a competitive edge',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: 'With rising costs, it is essential to utilize these tools to optimize your business operations.',
          cover: `${process.env.ASSETS_PREFIX}/why-chowbus-pos.png`,
          items: [
            { desc: `Empower your staff and save labor with Kiosk, QR Code Ordering and Tablet Ordering.` },
            {
              desc: `Optimize your delivery service efficiency and maximize revenue with the power of Online Ordering and 3rd Party Delivery Integrations.`,
            },
            { desc: `Streamline diner traffic and attract new customers with Waitlist.` },
          ],
        },

        {
          layout: 'row',
          direction: 'reverse',
          title: 'Now, effortlessly manage your restaurant and instantly captivate your customers.',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_2.png`,
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_1.png`,
          items: [
            { desc: `Make your customer relationships stronger and more profitable with Restaurant Loyalty Program` },
            { desc: `Effortlessly access and manage your menus, orders, and team with our cloud-based software.` },
            {
              desc: `Gain valuable insights into your business through comprehensive sales reports and customer activity analysis, empowering you to make informed decisions.`,
            },
          ],
        },
      ],
    },
    zh: {
      title: '选择有竞争优势的技术解决方案',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '餐厅成本上升，充分利用这些工具来优化您的业务至关重要',
          cover: `${process.env.ASSETS_PREFIX}/why-chowbus-pos.png`,
          items: [
            { desc: `赋能您的员工，并通过智能自助点餐机、二维码点餐和平板点餐节省人工成本。` },
            { desc: `通过餐厅订单网页和第三方外卖平台集成，优化您的外卖服务效率并最大化收入。` },
            { desc: `通过排队等位系统，优化餐厅客流并吸引新客户。` },
          ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: '从现在开始，轻松管理您的餐厅，即刻吸引您的顾客',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_2.png`,
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_1.png`,
          items: [
            { desc: `通过餐厅专属会员系统，使您与顾客的关系更加紧密。` },
            { desc: `借助我们的云端餐饮管理系统，轻松访问和管理您的菜单、订单和团队。` },
            { desc: `通过全面的销售报告和顾客活动分析，获得对您的业务宝贵的洞察力，帮助您做出明智的决策。` },
          ],
        },
      ],
    },
  },

  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-machimachi.jpeg`,
      productLine: 'Loyalty',
      desc: {
        zh: `“我们从开业时开始使用Chowbus POS，最近开始用自助点餐机。40%的堂食顾客使用了点餐机，因为它有大屏幕展示图片，非常用户友好。超过三分之一使用点餐机的顾客成为我们的会员。我们最大的痛点之一是有时候我们有很长的队伍等待点餐，幸运的是Chowbus自助点餐机帮助我们解决了这个问题。”  `,
        en: `"We've started using Chowbus POSwhen we opened and recently added the Chowbus Kiosk, 40% of our dine-in customers utilize the Kiosk because it has a large display with plenty of pictures and is extremely user friendly. Over a third of our customers who use our Kiosk become our members, which helps us build our membership base. Historically, one of our biggest pain points is that sometimes we have a long queue of customers waiting to place their orders and thankfully Chowbus Kiosk has helped us solve this issue."     `,
      },
      restaurantName: { zh: 'Machi Machi', en: 'Machi Machi' },
      location: { zh: '纽约', en: 'New York, NY' },
      link: '/customer-case/boba-tea-dessert/machi-machi',
    },
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-shinyaramen_2.jpeg`,
      productLine: 'QR Code',
      desc: {
        zh: `“我们通过采用无接触的二维码点餐，将翻桌率提高了30％，并成功减少了两名员工。一些服务员担心使用二维码后可能无法得到像以前那样多的小费，但其实我们的小费平均增加了近35％，因为服务员现在可以专注于与顾客互动。” `,
        en: `"By adopting contactless QR code ordering, Shinya Ramen increased the table turnover rate by 30% and was able to cut two more headcounts. Some of our waiters and waitresses worry that by using QR code, they would not get as many tips as before. The concern was quickly dispelled. Our average tip percentage has increased almost 35% because waiters and waitresses can now focus on table touching and making personal connections with the guests."  `,
      },
      restaurantName: { zh: '深夜食堂', en: 'Shinya Ramen' },
      location: { zh: '芝加哥', en: 'Chicago, IL' },
      link: '/customer-case/sushi-ramen/shinya-ramen-house',
    },
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-jongrobbq.jpeg`,
      productLine: 'Handheld',
      desc: {
        zh: `“Chowbus手持POS让我们的员工有更多的时间处理其他任务，与客人互动，为客人创造更丰富的用餐体验。Chowbus团队始终非常专业。我很喜欢他们的服务团队，当你有任何问题时，他们会在30分钟内来到店铺。这种到店支持非常有帮助。”   `,
        en: `“Chowbus POS Handheld frees our staff time to handle other value-added tasks, engage with guests, and build rapport, which creates a more fulfilling dining experience for both guests and staff. The team from Chowbus is always on point. I actually like their support team because when you text them with any issues, they will come to your store within 30 mins. The personal connection helps a lot.”   `,
      },
      restaurantName: { zh: `Jongro BBQ`, en: `Jongro BBQ` },
      location: { zh: '纽约', en: 'New York' },
      link: '/customer-case/korean-bbq/jongro-bbq',
    },
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-kajiken.jpeg`,
      productLine: 'Tablet Ordering',
      desc: {
        zh: `“我们面临的最大问题之一是让服务员把所有事情写下来并记住。Chowbus平板点餐使我们餐厅的一切变得更顺利。食物上菜更快，订单更快送到厨房，错误更少。我们的小费甚至增加了3倍！”  `,
        en: `“One of our biggest issues was trying to have servers write everything down and remember everything. The Chowbus Tablet Ordering has smoothed out everything in the restaurant. The food comes out quicker, tickets get to the kitchen faster, and there are fewer errors. Our tips even increased 3X!”  `,
      },
      restaurantName: { zh: `KAJIKEN`, en: `KAJIKEN` },
      location: { zh: '巴尔的摩', en: 'Baltimore' },
      link: '/customer-case/sushi-ramen/kajiken',
    },
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-teamobobabar.jpeg`,
      productLine: 'Kiosk',
      desc: {
        zh: `“Chowbus是唯一一家同时为餐厅提供外卖服务的POS公司，与自助点餐机结合，我们能更好地了解我们的顾客。我可以感觉到他们真的关心客户，这与我们的使命相一致。由于Chowbus团队真正关注我们的困难，我觉得与他们合作就像建立伙伴关系。我们一起努力提高效率和顾客满意度。”`,
        en: `“Chowbus is the only POS company that also does delivery for restaurants, integrated with kiosks, we could understand our customers better. I can tell they (Chowbus team) really care about customers, which aligns with our mission. Our mission is to spread love wherever I go. With the Chowbus team genuinely concerned about our struggles and hardship, I feel working with them is like building a partnership. We work as a team to improve efficiency and customer satisfaction.”  `,
      },
      restaurantName: { zh: `享茶`, en: `Te'amo Boba Bar` },
      location: { zh: '芝加哥', en: 'Chicago, IL' },
      link: '/customer-case/boba-tea-dessert/teamo-boba-bar',
    },

    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-mrsgu.jpeg`,
      productLine: 'Online Ordering',
      desc: {
        zh: `“我非常喜欢Chowbus POS，因为我可以直接拿着iPad在顾客面前结账。它可以直接连接到WIFI，刷卡速度超快！通过电子结账极大地帮助我们的团队节省了打印成本。”  `,
        en: `“I really like Chowbus POS since I can just bring the iPad with me and do the check-outs for customers in front of them. It connects to the WIFI directly, and the swiping speed is super fast! Checking out digitally immensely helped the team save the printing cost.”  `,
      },
      restaurantName: { zh: `顾大姐串串香火锅`, en: `Mrs. Gu` },
      location: { zh: '芝加哥', en: 'Chicago, IL' },
      link: '/customer-case/hot-pot/mrs-gu',
    },
  ],
};

const WhyChowbusPOS = () => {
  const locale = useLocale();
  const screens = useBreakpoint();
  let intl = useIntl();
  const { poster, title, description, moreDescription } = SectionContent['topSection'][locale];
  const { title: featureTitle, subTitle: featureSubTitle, featureList } = SectionContent['features'][locale];
  const { title: advanceTitle, items: advanceList } = SectionContent['advances'][locale];
  const customerVoiceInfos = SectionContent['customerVoiceInfos'];
  const { keywords, pageTitle, metaDescription } = useSEOMeta({ pageId: 'pos-why-chowbus-pos' });
  return (
    <GeneralLayout
      pageClass="full-width-page"
      pageId={'pos-why-chowbus-pos'}
      pageTitle={pageTitle}
      keywords={keywords}
      metaDescription={metaDescription}
    >
      <div className={styles.PageProductThirdpartyIntegration}>
        <CommonSectionLayout backgroundColor="#fffff" title={''}>
          <div className="topSection">
            <DescriptionCardV2
              posterRatio={492 / 672}
              title={title}
              description={''}
              poster={poster}
              posterAlt={title}
              direction={'reverse'}
              youtubeVideoId={''}
              autoPlayOnCover={true}
            >
              <div>
                <div className="description-content">{description}</div>
                <div className="description-content-more">
                  {moreDescription.map(({ title, content }, index) => {
                    return (
                      <div className="description-content-item" key={index}>
                        <div className="description-content-title">{title}</div>
                        <div className="description-content">{content}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </DescriptionCardV2>
          </div>
        </CommonSectionLayout>
        <CommonSectionLayout backgroundColor="#FAFAFA" title={featureTitle}>
          <div className="features-section">
            <CompareTable locale={locale} />
          </div>
        </CommonSectionLayout>
        <ScheduleYourFreeDemo />
        <CommonSectionLayout
          backgroundColor="#F5F5F5"
          title={advanceTitle}
          classNames="table-ordering-advance-container"
        >
          {advanceList.map((advanceCard, index) => {
            return (
              <div className="advance-section" key={index}>
                <POSProductAdvanceCard {...advanceCard}></POSProductAdvanceCard>
              </div>
            );
          })}
        </CommonSectionLayout>

        <CommonSectionLayout backgroundColor="#ffffff" title={''} classNames={styles.bottomShowBaseContainer}>
          <div className={styles.customerVoiceList}>
            <Carousel
              autoplaySpeed={10000}
              dots={true}
              dotPosition={'bottom'}
              autoplay={false}
              infinite
              centerMode={true}
              slidesPerRow={1}
              centerPadding={'0px'}
            >
              {customerVoiceInfos.map((info, index) => {
                let order = 'reverse';
                let { img, desc, restaurantName, location, link } = info;
                return (
                  <CustomerVoiceCard
                    darkMode={false}
                    key={index}
                    restaurantName={restaurantName[locale]}
                    location={location[locale]}
                    img={img}
                    link={link}
                    desc={desc[locale]}
                    order={order}
                  ></CustomerVoiceCard>
                );
              })}
            </Carousel>
          </div>
        </CommonSectionLayout>
      </div>
    </GeneralLayout>
  );
};

const CompareTableRowGroup = ({ children, ref }) => {
  const screens = useBreakpoint();

  const [rowGroupHiehgt, setRowGroupHiehgt] = useState('auto');

  const compareRowGroupRef = useRef();

  const resizeHandler = useCallback(() => {
    if (compareRowGroupRef.current) {
      let contentHeight = compareRowGroupRef.current.getBoundingClientRect().height;
      setRowGroupHiehgt(`${contentHeight}px`);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    resizeHandler();
    const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    window.addEventListener(resizeEvt, resizeHandler, false);
    return () => {
      window.removeEventListener(resizeEvt, resizeHandler, false);
    };
    // eslint-disable-next-line
  }, [resizeHandler]);

  return (
    <div className={styles.compare_row_group} ref={compareRowGroupRef} style={{ '--row-group-height': rowGroupHiehgt }}>
      {children}
    </div>
  );
};

const CompareTable = ({ locale }) => {
  const screens = useBreakpoint();

  const [showMoreFeatureFlag, setShowMoreFeatureFlag] = useState(false);
  const [showOnMobileView, setShowOnMobileView] = useState(false);
  const [selectedTargets, setSelectedTargets] = useState(['menusifu', 'clover']);

  const handleTargetChange = (value, index) => {
    setSelectedTargets((prev) => {
      let newTargets = [...prev];
      newTargets[index] = value;
      return newTargets;
    });
  };

  useEffect(() => {
    if (screens.xs) {
      setSelectedTargets(['menusifu', 'clover']);
    } else {
      setSelectedTargets((prev) => {
        if (prev[0] !== 'menusifu') {
          return ['menusifu', prev[0]];
        } else {
          return prev;
        }
      });
    }
  }, [screens.xs]);
  const menuPropsList = [
    {
      options: compareTargetOptions.slice(0, 1),
      value: (
        compareTargetOptions.slice(0, 1).find(({ value }) => value === selectedTargets[0]) || { value: 'menusifu' }
      ).value,
      defaultValue: 'menusifu',
      onChange: (value) => handleTargetChange(value, 0),
    },
    {
      options: compareTargetOptions.slice(1),
      defaultValue: 'clover',
      value: (compareTargetOptions.slice(1).find(({ value }) => value === selectedTargets[1]) || { value: 'clover' })
        .value,
      onChange: (value) => handleTargetChange(value, 1),
    },
    {
      options: compareTargetOptions,
      defaultValue: 'menusifu',
      value: (compareTargetOptions.slice(1).find(({ value }) => value === selectedTargets[0]) || { value: 'menusifu' })
        .value,
      onChange: (value) => handleTargetChange(value, 0),
    },
  ];

  const onClickShowMoreFeature = useCallback(() => {
    setShowMoreFeatureFlag((prev) => {
      return !prev;
    });
  }, []);
  const COLUMN_FLEX = useMemo(() => {
    if (screens.xs) {
      return [4, 3, 2, 2];
    } else {
      return [3, 3, 2, 2, 2];
    }
  }, [screens.xs]);

  return (
    <Fragment>
      <div className={styles.compare_table}>
        <div className={styles.compare_header}>
          {!screens.xs && <div className={styles.compare_column} style={{ flex: COLUMN_FLEX[0] }}></div>}
          <div className={styles.compare_column} style={{ flex: COLUMN_FLEX[1] }}></div>
          <div className={styles.compare_column} style={{ flex: COLUMN_FLEX[2], fontSize: '16px' }}>
            <img src={chowbus_logo_why_chowbus_pos} alt="chowbus logo" className={styles.chowbus_logo} />
          </div>
          <div
            className={styles.compare_column}
            style={{ flex: COLUMN_FLEX[3], fontSize: '16px', color: 'inherit', fontWeight: 'normal' }}
          >
            {!screens.xs ? (
              menuPropsList[0].options[0].label
            ) : (
              <Select
                // style={{ width: 120 }}
                bordered={false}
                size="small"
                readon
                {...(!screens.xs ? menuPropsList[0] : menuPropsList[2])}
              />
            )}
          </div>
          {!screens.xs && (
            <div className={styles.compare_column} style={{ flex: COLUMN_FLEX[4] }}>
              <Select
                // style={{ width: 120 }}
                bordered={false}
                size="small"
                {...menuPropsList[1]}
              />
            </div>
          )}
        </div>
        <div className={styles.compare_body}>
          {/* ---客户服务-- */}
          {compareTalbeData.slice(0, !showMoreFeatureFlag ? 4 : compareTalbeData.length).map((compareData, index) => {
            return (
              <CompareTableRowGroup key={index}>
                {compareData.map((row, index) => {
                  let {
                    serviceCategory,
                    serviceCategory_foreign,
                    service,
                    service_foreign,
                    chowbus,
                    toast,
                    clover,
                    square,
                    menusifu,
                    zbs_pos,
                  } = row;
                  serviceCategory = locale === LOCALE_ZH ? serviceCategory : serviceCategory_foreign;
                  service = locale === LOCALE_ZH ? service : service_foreign;
                  return (
                    <div className={styles.compare_row} key={`${serviceCategory}-${service}`}>
                      {!screens.xs && (
                        <div
                          className={`${styles.compare_column} ${styles.first} ${index !== 0 ? styles.span : ''}`}
                          style={{ flex: COLUMN_FLEX[0], border: 0 }}
                        >
                          <div className={styles.row_span_shadow}>{serviceCategory}</div>
                        </div>
                      )}

                      <div className={styles.compare_column} style={{ flex: COLUMN_FLEX[1] }}>
                        {service}
                      </div>
                      <div className={styles.compare_column} style={{ flex: COLUMN_FLEX[2] }}>
                        {chowbus && (
                          <img src={checkbox_small} alt="feature enable" className={styles.chowbus_feature_checked} />
                        )}
                      </div>
                      <div className={styles.compare_column} style={{ flex: COLUMN_FLEX[3] }}>
                        {row[selectedTargets[0]] && (
                          <img src={checked_icon} alt="feature enable" className={styles.feature_checked_icon} />
                        )}
                        {/* {toast ? 'Y' : 'N'} */}
                      </div>
                      {!screens.xs && (
                        <div className={styles.compare_column} style={{ flex: COLUMN_FLEX[4] }}>
                          {/* {menusifu ? 'Y' : 'N'} */}
                          {row[selectedTargets[1]] && (
                            <img src={checked_icon} alt="feature enable" className={styles.feature_checked_icon} />
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </CompareTableRowGroup>
            );
          })}
          {/* ---end-- */}
        </div>
      </div>
      <div className={styles.moreButtonsContainer}>
        <Button type="link" onClick={onClickShowMoreFeature}>
          {!showMoreFeatureFlag ? (
            <>
              <FormattedMessage id="home.why.chowbus.pos.showmorefeature.button" />
              <DownOutlined />
            </>
          ) : (
            <>
              <FormattedMessage id="home.why.chowbus.pos.showlessfeature.button" />
              <UpOutlined />
            </>
          )}
        </Button>
      </div>
    </Fragment>
  );
};
export default WhyChowbusPOS;

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}
